export default __webpack_public_path__ + "static/media/smarttravel.184c816d.jpeg";